import {create} from 'zustand';
import {SummaryAbandonFlowStore} from './types';

const useSummaryAbandonFlowStore = create<SummaryAbandonFlowStore>(set => ({
	summaryAbandonFlow: false,
	setSummaryAbandonFlow: value => set({summaryAbandonFlow: value}),
}));

export {useSummaryAbandonFlowStore};
